var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSixblocksShambles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_862",
    "data-name": "Group 862",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.015,
    height: 25.845,
    viewBox: "0 0 30.015 25.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M0,6.876H3.437V3.438H6.876V0H0Z",
    transform: "translate(13.812)",
    fill: "#28b6ea",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M10.313,3.438V0H0V6.875H3.438V3.438Z",
    transform: "translate(0 18.713) rotate(-90)",
    fill: "#86bc44",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M25.006,45.959v6.875H21.568V49.4H18.13V42.521h3.438v3.438Z",
    transform: "translate(-7.755 -28.965)",
    fill: "#5b3061",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M0,3.438v6.875H3.438V6.875H6.876V0H3.438V3.438Z",
    transform: "translate(4.933 2.705)",
    fill: "#b44784",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M6.875,10.313V0H3.437V3.437H0V6.875H3.437v3.438Z",
    transform: "translate(25.621 15.978) rotate(180)",
    fill: "#ca1d2a",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M0,10.314H3.437V6.876H6.876V3.438h3.438V0H3.437V3.438H0Z",
    transform: "translate(19.701 15.531)",
    fill: "#f98526",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixblocksShambles);
export default __webpack_public_path__ + "static/media/sixblocks-shambles.1a2816e2b3049b0d6072f7ca8736c918.svg";
export { ForwardRef as ReactComponent };